export default {
    'project'           : 'Cancer & Covid' , 
    'project_slug'      : 'covid' , 
    'publicPath'        : 'cervical_cancer_elimination',
    'margin'            : { top: 30, right: 200, bottom: 80, left: 100, top_page: 0, left_page: 0 , title_height : 70 } , 
    'data_version'      : '2020', // or 8.2, or whatever
    'data'      : {
        '2020' : {'years_available' : [2020,2120], 'year_prediction' : 2020, 'label' : '2020'  },
    },
    'years_available' :[2020,2120],
    'year_counter' : 5 , 
    'all_cancers_id'    : 39 , 
    'exclude_all_cancers_id' : [39,15,40] ,//DXX, grouped, all   
    'all_cancers_ids_list' : [15,37,39,40,11,38] ,
    'languages' : ["en"] , 
    'languages_labels' : [
        { "iso" : "en" , "label" : "English" }
    ] ,
    'check_availability' : false , 
    'predefined_population' : false , 
    'all_populations'   : [900] , 
    'hdi_populations' : [984,983,982,981] ,
    'groupings' : {}, 
    'year_base' : 2020 ,
    'main_color' : '#3D7C3F' ,  
    'color_no_data'   : '#7d7d80',
    'color_outmap'   : '#f0f0f0',
    'colors_types' : ['#0355a1','#d91616'], 
    'colors_sexes' : ['#3383b8','#ad027d'], 
    'colors_ages' : ["#4e79a7","#f28e2c","#e15759","#76b7b2","#59a14f","#edc949","#af7aa1","#ff9da7","#9c755f","#bab0ab","#1b9e77","#d95f02","#7570b3","#e7298a","#66a61e","#e6ab02","#a6761d","#666666"] , 
    'colors_scenario' :  [ '#CCCCCC' , '#FFAEBC', '#A0E7E5' , '#B4F8C8' , '#FBE7C6' ] , 
    'colors_delay' :  [ '#17CF5F' , '#220639B', '#3CAAEA3' , '#F6D55C' , '#ED553B' ] ,
    'pillar' : [ 
        { 'key' : 'vaccination' , 'code' : 1 , 'label' : 'Vaccination' , 'color' : '#4495d1'},
        { 'key' : 'screening' , 'code' : 2 , 'label' : 'Screening' ,  'color' : '#71bf43'},
        { 'key' : 'treatment' , 'code' : 3 , 'label' : 'Treatment' , 'color' : '#f7931d' }
    ],
    'delays' : [
        { "value" : 0 , "color" : "#17CF5F" , "label" : "No delay" },
        { "value" : 1 , "color" : "#20639B" , "label" : "Vax delays" },
        { "value" : 2 , "color" : "#3CAEA3" , "label" : "Catx delays" },
        { "value" : 3 , "color" : "#F6D55C" , "label" : "Catx&Scrn delays" },
        { "value" : 4 , "color" : "#ED553B" , "label" : "All delays" }
    ],
    'scenarios' : [
        { "value" : 0 , "color" : "#CCCCCC" , "label" : "S0" },
        { "value" : 1 , "color" : "#46244C" , "label" : "S1" },
        { "value" : 2 , "color" : "#C74B50" , "label" : "S2" },
        { "value" : 3 , "color" : "#FFD93D" , "label" : "S3" },
        { "value" : 4 , "color" : "#6BCB77" , "label" : "S4" },
        { "value" : 5 , "color" : "#D49B54" , "label" : "S5" }
    ],
    'ages_start'        : [0,5,10,15,20,25,30,35,40,45,50,55,60,65,70,75,80,85], 
    'ages_labels' : ['0-4','5-9','10-14','15-19','20-24','25-29','30-34','35-39','40-44','45-49','50-54','55-59','60-64','65-69','70-74','75-79','80-84'], 
    'indicators' : [
        {'key' : 'total' , 'label' : 'Absolute numbers' } ,
        {'key' : 'percent' , 'label' : '% of progression since 2020' } 
    ] , 
    'isos' : {
    },
    'print' : {
        'delay_puppetter' : 4000 ,
        'width_png' : 1480 , 
        'height_png' : 832 , 
        'width_pdf' : 1480 , 
        'height_pdf' : 860 , 
        'delay_loader' : 4500 
    } , 
    'max_filename_length' : 60 , 
    'key_title' : 'Age standardized-rate' , 
    'significant_digit' : 3 , 
    'home_graphics' : [
        { "name" : "Multi bars" , "offset" : "col-md-offset-1" ,  "active" : "active" , "icon" : "icons/svg/orange/bar.svg" } , 
        { "name" : "Pie chart" , "offset" : undefined , "active" : "active" , "icon" : "icons/svg/orange/pie_chart.svg"  } , 
        { "name" : "Dual bars" , "offset" : undefined , "active" : "active" , "icon" : "icons/svg/orange/dual.svg" } , 
        { "name" : "Maps" , "offset" : undefined , "active" : "active" , "icon" : "icons/svg/orange/connection_map.svg" } , 
        { "name" : "Globe" , "offset" : undefined , "class" : " globe_icon" , "active" : "active" , "icon" : "icons/svg/orange/globe.svg"} , 
        { "name" : "Tree map" , "offset" : "col-md-offset-1" ,  "active" : "active" , "icon" : "icons/svg/orange/treemap.svg"  } , 
        { "name" : "Scatter plot" , "offset" : undefined , "active" : "active" , "icon" : "icons/svg/orange/scatterplot.svg"  } , 
        { "name" : "Table" , "offset" : undefined , "active" : "active" , "icon" : "icons/svg/orange/time_table.svg" } , 
        { "name" : "Sunburst" , "offset" : undefined , "active" : "active" , "icon" : "icons/svg/orange/sunburst.svg"  },
        { "name" : "Maps (cancer site ranking)" , "is_new" : true , "offset" : undefined , "active" : "active" , "icon" : "icons/svg/orange/connection_map.svg"} // , 
    ], 
    'enable_population_grouping' : true ,
    'prevent_sex_specific' : true , 
    'population_select_close_on_select' : true ,
    'force_population_sort_alphabetical' : true , 
    'cancer_select_close_on_select' : true ,
    'allow_both_sexes_combined' : true ,
    'populations_isos' :['AFG', 'AGO', 'BGD', 'BTN', 'BOL', 'SLB', 'MMR', 'BDI', 'KHM',
       'CMR', 'CPV', 'CAF', 'LKA', 'TCD', 'COM', 'COG', 'COD', 'BEN',
       'SLV', 'ETH', 'ERI', 'DJI', 'GEO', 'GMB', 'PSE', 'GHA', 'GIN',
       'HTI', 'HND', 'IND', 'IDN', 'CIV', 'KEN', 'PRK', 'KGZ', 'LAO',
       'LSO', 'LBR', 'MDG', 'MWI', 'MLI', 'MRT', 'MNG', 'MDA', 'MAR',
       'MOZ', 'NPL', 'VUT', 'NIC', 'NGA', 'PAK', 'PNG', 'PHL', 'GNB',
       'TLS', 'RWA', 'STP', 'SEN', 'SLE', 'VNM', 'SOM', 'ZWE', 'SSD',
       'SDN', 'SWZ', 'SYR', 'TJK', 'TGO', 'TUN', 'UGA', 'UKR', 'EGY',
       'TZA', 'BFA', 'UZB', 'YEM', 'ZMB'],
    "options_ages_start" : [
        { value: 0, label: '0' },
        { value: 1, label: '5' },
        { value: 2, label: '10' },
        { value: 3, label: '15' },
        { value: 4, label: '20' },
        { value: 5, label: '25' },
        { value: 6, label: '30' },
        { value: 7, label: '35' },
        { value: 8, label: '40' },
        { value: 9, label: '45' },
        { value: 10, label: '50' },
        { value: 11, label: '55' },
        { value: 12, label: '60' },
        { value: 13, label: '65' },
        { value: 14, label: '70' },
        { value: 15, label: '75' },
        { value: 16, label: '80' }
      ],
     "options_ages_end" : [
        { value: 0, label: '4' },
        { value: 1, label: '9' },
        { value: 2, label: '14' },
        { value: 3, label: '19' },
        { value: 4, label: '24' },
        { value: 5, label: '29' },
        { value: 6, label: '34' },
        { value: 7, label: '39' },
        { value: 8, label: '44' },
        { value: 9, label: '49' },
        { value: 10, label: '54' },
        { value: 11, label: '59' },
        { value: 12, label: '64' },
        { value: 13, label: '69' },
        { value: 14, label: '74' },
        { value: 15, label: '79' },
        { value: 16, label: '84' }
      ],
      "slider_ages_max" : 16
  }